import { render } from "./AGData.vue?vue&type=template&id=597796e2&scoped=true"
import script from "./AGData.vue?vue&type=script&lang=js"
export * from "./AGData.vue?vue&type=script&lang=js"

import "./AGData.vue?vue&type=style&index=0&id=597796e2&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597796e2"]])

export default __exports__